export const FETCH_NETWORK_LOGS_LOADING = "FETCH_NETWORK_LOGS_LOADING";
export const FETCH_NETWORK_LOGS_SUCCESS = "FETCH_NETWORK_LOGS_SUCCESS";
export const FETCH_NETWORK_LOGS_ERROR = "FETCH_NETWORK_LOGS_ERROR";
export const FETCH_NETWORK_HAR_LOGS_LOADING = "FETCH_NETWORK_HAR_LOGS_LOADING";
export const FETCH_NETWORK_HAR_LOGS_SUCCESS = "FETCH_NETWORK_HAR_LOGS_SUCCESS";
export const FETCH_NETWORK_HAR_LOGS_ERROR = "FETCH_NETWORK_HAR_LOGS_ERROR";
export const CLEAR_NETWORK_LOGS = "CLEAR_NETWORK_LOGS";
export const SET_NETWORK_FULL_HAR_LOGS = "SET_NETWORK_FULL_HAR_LOGS";
